"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "directions", {
  enumerable: true,
  get: function get() {
    return _oxygenFlyout.directions;
  }
});
Object.defineProperty(exports, "directionsType", {
  enumerable: true,
  get: function get() {
    return _oxygenFlyout.directionsType;
  }
});
exports.default = exports.showOnTypes = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _oxygenConstants = require("@8x8/oxygen-constants");

var _oxygenConfig = require("@8x8/oxygen-config");

var _oxygenFlyout = _interopRequireWildcard(require("@8x8/oxygen-flyout"));

var _oxygenStaticTooltip = _interopRequireDefault(require("@8x8/oxygen-static-tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var showOnTypes = {
  hover: 'hover',
  click: 'click'
};
exports.showOnTypes = showOnTypes;

var Tooltip =
/*#__PURE__*/
function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isShown: false
    });

    _defineProperty(_assertThisInitialized(_this), "showTooltip", function () {
      _this.displayTimeout = setTimeout(function () {
        _this.setState({
          isShown: true
        });
      }, _this.props.delay);
    });

    _defineProperty(_assertThisInitialized(_this), "hideTooltip", function () {
      clearTimeout(_this.displayTimeout);

      _this.setState({
        isShown: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleTooltip", function () {
      _this.setState({
        isShown: !_this.state.isShown
      });
    });

    _defineProperty(_assertThisInitialized(_this), "anchorRef", _react.default.createRef());

    return _this;
  }

  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          testId = _this$props.testId,
          delay = _this$props.delay,
          orientation = _this$props.orientation,
          showOn = _this$props.showOn,
          children = _this$props.children,
          triggerRef = _this$props.triggerRef,
          restProps = _objectWithoutProperties(_this$props, ["title", "testId", "delay", "orientation", "showOn", "children", "triggerRef"]);

      var ChildrenWrapper = _react.default.createElement("span", _extends({
        ref: triggerRef || this.anchorRef
      }, showOn === showOnTypes.click ? {
        onClick: this.toggleTooltip
      } : {
        onMouseOver: this.showTooltip,
        onMouseOut: this.hideTooltip
      }, (0, _oxygenConfig.getTestAttributes)("ANCHOR_FOR_".concat(testId))), children);

      return _react.default.createElement(_react.Fragment, null, ChildrenWrapper, _react.default.createElement(_oxygenFlyout.default, _extends({
        anchor: triggerRef && triggerRef.current || triggerRef || this.anchorRef.current,
        idealDirection: orientation,
        isShown: this.state.isShown,
        onBlur: this.hideTooltip,
        testId: "FLYOUT_FOR_".concat(testId)
      }, restProps), _react.default.createElement(_oxygenStaticTooltip.default, {
        testId: "STATIC_TOOLTIP_FOR_".concat(testId)
      }, title)));
    }
  }]);

  return Tooltip;
}(_react.Component);

_defineProperty(Tooltip, "propTypes", {
  title: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]).isRequired,
  testId: _propTypes.default.string,
  delay: _propTypes.default.number,
  orientation: _propTypes.default.oneOf(_oxygenFlyout.directionsType),
  showOn: _propTypes.default.oneOf(Object.values(showOnTypes)),
  children: _propTypes.default.node,
  triggerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
});

_defineProperty(Tooltip, "defaultProps", {
  delay: _oxygenConstants.tooltip.delay,
  testId: 'TOOLTIP',
  orientation: _oxygenFlyout.directions.top,
  showOn: showOnTypes.hover,
  children: null,
  triggerRef: undefined
});

var _default = Tooltip;
exports.default = _default;